export enum PagingBehavior {

    /**
     * If 'Dynamic', the paging will be done using the pre-calculated paging.links array property returned by the data source.
     */
    Dynamic = 'dynamic'
}